// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { type Point2D } from '../../../types/point';
import OddsTravelAnimation from '../components/OddsTravelAnimation';
import makeSelectOddsTravelAnimationProps from '../selectors/specifics/selectOddsTravelAnimationProps';

type OddsTravelAnimationContainerProps = {
  className?: string;
  oddId: number;
  from: Point2D;
  to: Point2D;
};

const OddsTravelAnimationContainer = ({ oddId, ...ownProps }: OddsTravelAnimationContainerProps) => {
  const selectorProps = useMemo(() => ({ oddId }), [oddId]);
  const selector = useMemo(() => makeSelectOddsTravelAnimationProps(), []);
  const selectedProps = useSelector((state) => selector(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <OddsTravelAnimation {...enhancedProps} />;
};

export default OddsTravelAnimationContainer;
